//https://api.czz3177o4e-sanofiave1-d2-public.model-t.cc.commerce.ondemand.com/sanofiusocc/v2/vsh/cms/pages?pageType=ContentPage&pageLabelOrId=stsMarketingAnalysisPage&lang=en&curr=USD
//STSMarketingAnalysisPageTemplate

import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { GlobalMessageService } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { StsAdminService } from '../sts-admin.service';

@Component({
  selector: 'app-sts-marketing-tool',
  templateUrl: './sts-marketing-tool.component.html',
  styleUrls: ['./sts-marketing-tool.component.scss'],
})
export class StsMarketingToolComponent implements OnInit, OnDestroy {
  materialNumberOptions: any[];
  msegList: any[];
  marketingListData: any[];
  programLevelList: string[];
  selectedMaterialNumberOptions: any;
  myModelProperty: any;
  stsMarketingAnalysisForm = this.fb.group({
    orderNumber: [''],
    materialNumber: [''],
    customerNumber: [''],
    programLevel: ['All'],
    mseg: [''],
  });
  weekList: string[];
  totalAverageVariance: number;
  sapTotalUnits: number;
  requestedUnits: number;
  updatedStsListData: any[];
  prevSelectedList: any[];
  stsSub: Subscription;

  constructor(
    private readonly stsAdminService: StsAdminService,
    private readonly cd: ChangeDetectorRef,
    private readonly fb: FormBuilder,
    private readonly globalMessage: GlobalMessageService
  ) {}

  ngOnInit(): void {
    const params = {
      orderNumber: '',
      customerNumber: '',
      materialNumber: [''],
      programLevel: [''],
      mseg: [''],
    };
    this.getDropdownOptions(params, 'onload');
  }
  ngOnDestroy(): void {
    this.stsSub?.unsubscribe();
  }
  getDropdownOptions(params, type) {
    this.stsAdminService.getDropdownList(params);
    this.stsSub = this.stsAdminService.dropdownOptions$.subscribe((res) => {
      if (res) {
        if (type == 'onload') {
          this.materialNumberOptions = res['productCodes'];
          this.msegList = res['msegList']['entry'];
          this.programLevelList = res['progLevel'];
          this.marketingListData = res?.stsMarketingDetails;
          this.calcOriginalUpdatedTotal();
          this.weekList = res['shippingWeeks'];
          this.totalAverageVariance = res['totalAverageVariance'];
          this.sapTotalUnits = res['sapTotalUnits'];
          this.requestedUnits = res['requestedUnits'];
          this.cd.detectChanges();
        }
        if (type == 'save') {
          this.marketingListData = res?.stsMarketingDetails;
          this.calcOriginalUpdatedTotal();
          this.weekList = res['shippingWeeks'];
          this.totalAverageVariance = res['totalAverageVariance'];
          this.sapTotalUnits = res['sapTotalUnits'];
          this.requestedUnits = res['requestedUnits'];
          this.cd.detectChanges();
        }
      }
    });
  }

  downloadStsXls() {
    let arr = [
      {
        '': 'Total:',
        Customer: 'Total:',
        Reservation: 'Total:',
        Presentation: 'Total:',
        Requested: 'Total:',
        'SAP Total': 'Total:',
        'Units change': 'Total:',
        'Ship change': 'Total:',
        'Ship Accuracy': 'Total:',
        Variance: 'Total:',
      },
      {
        '': 'Level',
        Customer: 'Customer',
        Reservation: 'Reservation',
        Presentation: 'Presentation',
        Requested: 'Requested',
        'SAP Total': 'SAP Total',
        'Units change': 'Units change',
        'Ship change': 'Ship change',
        'Ship Accuracy': 'Ship Accuracy',
        Variance: 'Variance',
      },
    ];
    this.marketingListData.forEach((marketingData) => {
      let obj = {
        '': marketingData.key.progLevel,
        Customer: marketingData.key.customerNumber,
        Reservation: marketingData.key.orderNumber,
        Presentation: marketingData.key.materialNumber,
        Requested: marketingData.key.requested,
        'SAP Total': marketingData.key.sapTotal,
        'Units change': marketingData.key.unitChange,
        'Ship change': marketingData.key.shipChange,
        'Ship Accuracy': marketingData.key.shipAcuracy,
        Variance: marketingData.key.variance,
      };
      marketingData.value.shippingData.forEach((shippingData) => {
        arr[0][`Week of ${shippingData.shippingWeek}`] = 0;
        arr[0][`Week of ${shippingData.shippingWeek}_1`] = 0;
        arr[1][`Week of ${shippingData.shippingWeek}`] = 'Original';
        arr[1][`Week of ${shippingData.shippingWeek}_1`] = 'Updated';
        obj[`Week of ${shippingData.shippingWeek}`] = shippingData['quantity'];
        obj[`Week of ${shippingData.shippingWeek}_1`] =
          shippingData['adjustedquantity'];
      });
      arr.push(obj);
    });
    this.stsAdminService.downloadXls(arr, 'STS Marketing Analysis');
  }

  saveSTSMarketingDetails() {
    let updateList = [];
    let arr = JSON.parse(JSON.stringify(this.marketingListData));
    arr.forEach(
      (data) =>
        (data.value.shippingData = data.value.shippingData.filter(
          (shippingData) => shippingData.adjustedquantity > 0
        ))
    );
    arr = arr.filter((data) => data.value.shippingData.length > 0);
    arr.forEach((data) => {
      data.value.shippingData.forEach((shippingData) => {
        updateList.push({
          shippingWeek: shippingData['shippingWeek'],
          materialNumber: data['key']['materialNumber'],
          accountNumber: data['key']['customerNumber'],
          orderNumber: data['key']['orderNumber'],
          progLevel: data['key']['progLevel'],
          adjustedquantity: shippingData['adjustedquantity'],
          quantity: shippingData['quantity'],
          requestedQty: data['key']['requested'],
        });
      });
    });
    const params = {
      updateList: updateList,
    };
    this.stsAdminService.updateSTSMarketingDetails(params);
    this.stsAdminService.saveSTSMarketingDetails$.subscribe((res) => {
      if (res) {
        const params = {
          orderNumber: this.stsMarketingAnalysisForm.controls.orderNumber.value
            ? this.stsMarketingAnalysisForm.controls.orderNumber.value
            : '',
          customerNumber: this.stsMarketingAnalysisForm.controls.customerNumber
            .value
            ? this.stsMarketingAnalysisForm.controls.customerNumber.value
            : '',
          materialNumber: this.stsMarketingAnalysisForm.controls.materialNumber
            .value
            ? this.stsMarketingAnalysisForm.controls.materialNumber.value
            : [''],
          programLevel: this.stsMarketingAnalysisForm.controls.programLevel
            .value
            ? this.stsMarketingAnalysisForm.controls.programLevel.value
            : '',
          mseg: this.stsMarketingAnalysisForm.controls.mseg.value
            ? this.stsMarketingAnalysisForm.controls.mseg.value
            : [''],
        };
        this.getDropdownOptions(params, 'save');
      }
    });
  }

  changeView(type, event) {
    let values = event.map((item) => item);
    let valueString = values.join(', ');
    let dropdown = document.getElementById(type);
    let value = dropdown.getElementsByClassName('ng-value-container');
    for (var i = 0; i < value.length; i++) {
      value[i].innerHTML = valueString;
    }
  }

  onSearch() {
    const params = {
      orderNumber: this.stsMarketingAnalysisForm.controls.orderNumber.value,
      customerNumber:
        this.stsMarketingAnalysisForm.controls.customerNumber.value,
      materialNumber:
        this.stsMarketingAnalysisForm.controls.materialNumber.value,
      programLevel: this.stsMarketingAnalysisForm.controls.programLevel.value,
      mseg: this.stsMarketingAnalysisForm.controls.mseg.value,
    };
    this.getDropdownOptions(params, 'save');
  }

  calcOriginalUpdatedTotal() {
    if (this.marketingListData) {
      let obj = this.marketingListData[0];
      obj.value.shippingData.forEach((data) => {
        data['totalOriginal'] = 0;
        data['totalUpdated'] = 0;
        this.marketingListData.forEach((marketingData) => {
          let filter = marketingData?.value?.shippingData.filter(
            (shipData) => shipData?.shippingWeek == data?.shippingWeek
          );
          data['totalOriginal'] = data['totalOriginal'] + filter[0].quantity;
          data['totalUpdated'] =
            data['totalUpdated'] + filter[0].adjustedquantity;
        });
      });
    }
  }
}
